module.exports = __webpack_public_path__ + "static/media/learners.9d37ede3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainmenus/learners.png
// module id = 577
// module chunks = 0